'use client';

import { useEffect, useRef } from 'react';
import type { PropertyDetailListing } from '@/src/components/features/property/types';
import { hasBookableTourProvider } from '@/src/lib/utils/instantTourProviders';
import { BOOK_TOUR_HASH } from '@/src/lib/constants';
import { useTourAction } from './useTourAction';

/**
 * Opens the tour wizard when the page loads with the #book-tour hash — the
 * deep link published as `tourBookingPage` in the listing structured data.
 * One-shot: closing the wizard doesn't re-open it while the hash remains.
 */
export function BookTourHashOpener({ listing }: { listing?: PropertyDetailListing | null }) {
  const { openTour, tourOverlay } = useTourAction(listing, 'book_tour_hash');
  const opened = useRef(false);
  const bookable = hasBookableTourProvider(listing?.details?.instantTourProviders);

  useEffect(() => {
    if (opened.current || !bookable || window.location.hash !== `#${BOOK_TOUR_HASH}`) {
      return;
    }
    opened.current = true;
    openTour();
  }, [bookable, openTour]);

  return tourOverlay;
}
